const workflowInstanceFilters = {
  statusId: null
}

export default () => Object.assign({}, workflowInstanceFilters)
